import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata, ContentType } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Link } from '@amzn/awsui-components-core';

interface Props {
  contentId: string;
  metadata: ContentMetadata;
}

const TechWriterContentViewerlink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, metadata } = props;
  const appContext = useContext(AppContext);
  if (metadata.contentType === ContentType.Post) {
    return (
      <Link variant="secondary" href={`/post-viewer/${contentId}`}>
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    );
  } else {
    return (
      <Link variant="secondary" href={`/content-viewer/tech-writer/${contentId}`} target="_blank">
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    );
  }
};

export default TechWriterContentViewerlink;
